import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")

  return (_openBlock(), _createElementBlock("div", {
    ref: "notificator",
    class: _normalizeClass($options.notificatorClassList),
    "data-qa": "notificator"
  }, [
    ($props.withTransition)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 0,
          name: "gfu-notification-slide-and-fade",
          mode: "out-in",
          tag: "div"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.notifications, (notification) => {
              return (_openBlock(), _createBlock(_component_base_notificator, _mergeProps({
                key: notification.id
              }, { ref_for: true }, notification, {
                "can-close": $props.canClose,
                class: $options.createNotificationClass(notification),
                onClose: $event => ($options.onClose(notification))
              }), null, 16 /* FULL_PROPS */, ["can-close", "class", "onClose"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.notifications, (notification) => {
      return (_openBlock(), _createBlock(_component_base_notificator, _mergeProps({
        key: notification.id
      }, { ref_for: true }, notification, {
        "can-close": $props.canClose,
        class: $options.createNotificationClass(notification),
        onClose: $event => ($options.onClose(notification))
      }), null, 16 /* FULL_PROPS */, ["can-close", "class", "onClose"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}